import {useState, useEffect, useContext} from "react";
import { Context } from "../../containers/context/Context";

export const HeaderNameClient = () =>{

    const { app, user } = useContext(Context);

    
    const formatNitClient = (nit, country)=>{
        let result;
        let nitInit;
        let nitDV;
        const regex = /^[0-9]*$/;
        if(nit && regex.test(nit) && nit.length > 1 && country && country === 1){

            try {
                nitInit = parseInt(nit.substring(0,nit.length-1)).toLocaleString();
                nitDV = nit.substring(nit.length-1,nit.length);
                result = `${nitInit}-${nitDV}`
            } catch (error) {
                result = nit;
            }
        } else {
            result = nit;
        }
        return result;
    };

    const [nameClient, setNameClient] = useState(user.nombreEmpresa);
    const [nitClient, setNitClient] = useState(formatNitClient(user.nit,user.idPais));


    useEffect(()=>{
        setNameClient(user.nombreEmpresa);
        setNitClient(formatNitClient(user.nit, user.idPais))
    },[user]);

    return(
        <div className="company">
            <div className="company-img">
                <img src= {app.apiCore + "/uploads/afiliados/" + user.nit + "/images/logo_informes.png"} alt="" height="70"></img>
            </div>
            <div>
                <div className="name">{nameClient}</div>
                <div className="id">{nitClient}</div>
            </div>
        </div>
    );
}